import { defineComponent as r, toRef as i, h as a } from "vue";
import d from "./ghl-ui.es1487.js";
import f from "./ghl-ui.es882.js";
import c from "./ghl-ui.es849.js";
import b from "./ghl-ui.es1073.js";
const g = r({
  name: "BaseClose",
  props: {
    isButtonTag: {
      type: Boolean,
      default: !0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    focusable: {
      type: Boolean,
      default: !0
    },
    round: Boolean,
    onClick: Function,
    absolute: Boolean
  },
  setup(e) {
    return f("-base-close", d, i(e, "clsPrefix")), () => {
      const { clsPrefix: o, disabled: t, absolute: n, round: s, isButtonTag: l } = e;
      return a(
        l ? "button" : "div",
        { type: l ? "button" : void 0, tabindex: t || !e.focusable ? -1 : 0, "aria-disabled": t, "aria-label": "close", role: l ? void 0 : "button", disabled: t, class: [
          `${o}-base-close`,
          n && `${o}-base-close--absolute`,
          t && `${o}-base-close--disabled`,
          s && `${o}-base-close--round`
        ], onMousedown: (u) => {
          e.focusable || u.preventDefault();
        }, onClick: e.onClick },
        a(c, { clsPrefix: o }, {
          default: () => a(b, null)
        })
      );
    };
  }
});
export {
  g as default
};
